import { render, staticRenderFns } from "./relation.vue?vue&type=template&id=61a3e7ca&scoped=true&"
import script from "./relation.vue?vue&type=script&lang=js&"
export * from "./relation.vue?vue&type=script&lang=js&"
import style0 from "./relation.vue?vue&type=style&index=0&id=61a3e7ca&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61a3e7ca",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/manage.pc.frontend-purchase-test/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('61a3e7ca')) {
      api.createRecord('61a3e7ca', component.options)
    } else {
      api.reload('61a3e7ca', component.options)
    }
    module.hot.accept("./relation.vue?vue&type=template&id=61a3e7ca&scoped=true&", function () {
      api.rerender('61a3e7ca', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/system/common-usertags/relation.vue"
export default component.exports